export default {
  comparison: {
    aiCommand: {
      eyebrow: 'AI Command Centre Geofleet',
      title: 'Automatisation agentique depuis un seul centre de commande',
      intro:
        'Là où d’autres s’arrêtent aux cartes ou à des règles de dispatch basiques, l’AI Command Centre Geofleet orchestre l’allocation auto transporteurs, l’allocation auto chauffeurs, la planification agentique des tournées et des alertes & notifications intelligentes — avec des AI Agents qui agissent pour vous depuis une seule tour de contrôle.',
      ctaFeatures: 'Découvrir les AI Agents et l’automatisation',
      capabilities: {
        agents: {
          title: 'AI Agents',
          body: 'Des flux agentiques au centre de commande résolvent les exceptions, réaffectent le travail et coordonnent la logistique multi-étapes sans attendre un dispatcher humain.',
        },
        carrier: {
          title: 'Allocation auto transporteurs',
          body: 'L’IA associe chaque expédition au bon transporteur selon capacité, coût, SLA, historique de ligne et conditions en temps réel — en continu.',
        },
        driver: {
          title: 'Allocation auto chauffeurs',
          body: 'Les chauffeurs sont affectés et rééquilibrés automatiquement depuis la même tour que les transporteurs, avec proximité, compétences, shifts et charge dans un seul modèle.',
        },
        routes: {
          title: 'Planification agentique des tournées',
          body: 'Les tournées sont planifiées et replanifiées par du ML qui réagit au trafic, aux nouvelles commandes, aux échecs et aux contraintes de hubs.',
        },
        alerts: {
          title: 'Alertes & notifications IA',
          body: 'Alertes proactives sur risque SLA, retards, tension capacité et exceptions — priorisées par l’IA pour traiter l’essentiel en premier.',
        },
        tower: {
          title: 'Un seul centre de commande',
          body: 'Tout tourne dans un seul centre Geofleet : fini le patchwork d’outils silo pour routes, dispatch, partenaires et communications.',
        },
      },
    },
  },
};
